export default __webpack_public_path__ + "static/media/CapaCreateGroup.6b865a04.svg";